import React from "react";
import { motion } from "framer-motion";
import { Armchair, Users, Calendar, Star } from "@phosphor-icons/react";
import { useLanguage } from "@/context/LanguageContext";

const icons = [Armchair, Users, Calendar, Star];

export default function StatsSection() {
  const { t } = useLanguage();

  return (
    <section className="py-16 bg-[#121212] border-y border-white/5" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {t.stats.items.map((stat, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="text-center"
                data-testid={`stat-${i}`}
              >
                <Icon size={28} weight="duotone" className="text-[#FFD700] mx-auto mb-3" />
                <p className="font-['Cormorant_Garamond'] text-3xl md:text-4xl text-white font-light">{stat.value}</p>
                <p className="text-zinc-500 text-xs uppercase tracking-wider mt-1">{stat.label}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
